import { render, staticRenderFns } from "./SuggestedBillables.vue?vue&type=template&id=eb5e8b08&scoped=true"
import script from "./SuggestedBillables.vue?vue&type=script&lang=js"
export * from "./SuggestedBillables.vue?vue&type=script&lang=js"
import style0 from "./SuggestedBillables.vue?vue&type=style&index=0&id=eb5e8b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5e8b08",
  null
  
)

export default component.exports